"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellRangeNode = void 0;
exports.cellRangeNode = {
    hasChildNodes: false,
    getEvaluatorFunction: () => {
        throw new Error('Cell range handling not available');
    },
};
//# sourceMappingURL=cellRange.js.map